export const BAR_MAX_HEIGHT = 80;
export const CONFORT_BAR_OFFSET = 1;
